module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/maria_layer_on-3ee1f83b7865ad46e0410a05df7d3014.png";